import { Controller } from 'stimulus';

export default class extends Controller {
  static get targets() {
    return ['container'];
  }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this);
    window.addEventListener('keydown', this.boundKeydown);

    this.boundClickOutside = (event) => {
      if (event.target === this.containerTarget) {
        this.close();
      }
    };
    this.containerTarget.addEventListener('click', this.boundClickOutside);
  }

  disconnect() {
    window.removeEventListener('keydown', this.boundKeydown);
    if (this.boundClickOutside) {
      this.containerTarget.removeEventListener('click', this.boundClickOutside);
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && !this.containerTarget.classList.contains('hidden')) {
      this.close();
    }
  }

  closeOutside(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  open() {
    this.containerTarget.classList.remove('hidden');
    this.containerTarget.classList.remove('pointer-events-none');
  }

  close() {
    this.containerTarget.classList.add('hidden');
    this.containerTarget.classList.add('pointer-events-none');
  }
}
